export default {
  ADD_TO_HIGHLIGHTS: 'addToHighlights',
  REMOVE_COMPS_FROM_HIGHLIGHTS: 'removeCompsFromHighlights',
  SET_HIGHLIGHTS: 'setHighlights',
  CLEAR_HIGHLIGHTS: 'clearHighlights',
  REMOVE_FROM_HIGHLIGHTS_BY_HIGHLIGHT_TYPE:
    'removeFromHighlightsByHighlightType',
};
